import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import bm2payLogo from "./assets/img/bm2pay.svg";
import lightningChecksLogo  from "./assets/img/mainlogo.png";
import paxumLogo  from "./assets/img/paxum.png";
import { payinCheckLink , getQuoteDetails } from "api/clients";
import DivLoader from 'components/divloader/DivLoader';
import { allCountries } from 'utils/countryList';
import { BsCheck, BsCopy, BsLockFill } from 'react-icons/bs';
import { getCurrencySymbol } from "utils/currencyList"; 
import { QRCodeCanvas } from "qrcode.react";
import toast from 'react-hot-toast';
import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import Card from "components/card";

const hostname = window.location.hostname;
const logos : any = {
    'gateway-dev.lightningchecks.com': lightningChecksLogo,
    'gateway.lightningchecks.com': lightningChecksLogo,
    'testing.lightningchecks.com': lightningChecksLogo,
    'gateway-dev.bm2pay.com': bm2payLogo,
    'gateway.bm2pay.com': bm2payLogo,
    'gateway-stagging.bm2pay.com': bm2payLogo,
    'pay.paxum.com': paxumLogo,
};
const mainlogo = (
    <img
        style={{ height: "auto", width: hostname === "pay.paxum.com" ? "80px" : "30px" }}
        src={logos[hostname] || bm2payLogo}
        className="ml-2"
        alt="Gateway Image"
    />
);

interface CryptoPaymentData {
    first_name:string;
    last_name:string;
    email: string;
    phone: string;
    country: string;
    crypto_currency : string;
    blockchain_network : string;
}

function PayinCheckoutPage() {

    const { client_id, checkout_id, unique_payment_link_id , internal_tx_id } = useParams()
    const [initialLoading,setInitialLoading] = useState(true);
    const [client_secret,setClientSecret] = useState('');
    const [ipAddress,setIpAddress] = useState("0.0.0.0");
    const [brandColor, setBrandColor] = useState('#2020e4');
    const [style, setStyle] = useState("rounded");
    const [selectedFont, setSelectedFont] = useState("'Poppins'");
    const [timeLeft, setTimeLeft] = useState(0); 
    const [isExpired, setIsExpired] = useState(false);
    const [cryptoPaymentData, setCryptoPaymentData] = useState<CryptoPaymentData>({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country : 'CA',
        crypto_currency : "",
        blockchain_network : ""
    });
    const [addressPreview,setAddressPreview] = useState(false);
    const [cryptoErrors, setCryptoErrors] = useState<Record<string, string>>({});
    const [linkData,setLinkData] = useState<any>({})
    const [isLoading, setIsLoading] = useState<boolean>();
    const [cryptoAddress,setCryptoAddress] = useState("1FfmbHfnpaZjKFvyi1okTjJJusN455paPH")
    const [cryptoAmount,setCryptoAmount] = useState("0.00154568")
    const [copiedAddress, setCopiedAddress] = useState(false);
    const [copiedAmount, setCopiedAmount] = useState(false);
    const [finalPaymentAmount,setFinalPaymentAmount] = useState("");
    const [qrCode, setQrCode] = useState("");
    const [paymentAmountRate,setPaymentAmountRate] = useState("")
    const [targetDateTime, setTargetDateTime] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    
    useEffect(() => {
        if (targetDateTime) {
            const targetDate: any = new Date(targetDateTime); 
            
    
            let intervalId: NodeJS.Timeout; 
            
            const updateTimeLeft = () => {
                
                const currentTime: any = new Date();
                
                const difference = targetDate - currentTime;
    
                if (difference <= 0) {
                    setIsExpired(true);
                    setTimeLeft(0);
                    clearInterval(intervalId); 
                    onOpen();
                    setAddressPreview(false)
                } else {
                    setTimeLeft(difference);
                }
            };
    
            updateTimeLeft();
            intervalId = setInterval(updateTimeLeft, 1000); 
    
            return () => clearInterval(intervalId); 
        }
    }, [targetDateTime]);
    
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    const fetchData = async (loader : any) => {
        try {
            if(loader) {
                setInitialLoading(true)
            }
            if (client_id) {
                const client_secret = '';
                setClientSecret(client_secret);
                const checkLinkResponse = await payinCheckLink(client_id, checkout_id, unique_payment_link_id, client_secret);
                setLinkData(checkLinkResponse.data)
                setInitialLoading(false)

                const response_data = checkLinkResponse?.data?.crypto_details

                if(response_data.quote_id) {
                    setCryptoPaymentData(prev => ({
                        ...prev,
                        first_name: response_data.first_name,
                        last_name: response_data.last_name,
                        email: response_data.email,
                        phone: response_data.phone,
                        country: response_data.country,
                    }));
                    setFinalPaymentAmount(response_data.payment_amount)
                    setPaymentAmountRate(`${response_data.invoice_amount} ${response_data.invoice_currency} = ${response_data.payment_amount} ${response_data.payment_currency}`)
                    setCryptoAddress(response_data.payment_address)
                    setAddressPreview(true)
                    const targetDateFromAPI = new Date(checkLinkResponse?.data?.expires_at);
                    setTargetDateTime(targetDateFromAPI);
                }
            } 
            
        } catch (error) {
            setInitialLoading(false)
        }
    };

    const fetchIP = async () => {
        try {
            const response = await fetch('https://geolocation-db.com/json/');
            const data = await response.json();
            setIpAddress(data.IPv4);
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchData(true);
        fetchIP();
    }, [client_id]);

    const handleCryptoFieldChange = (field : any, value :any) => {
        setCryptoPaymentData({ ...cryptoPaymentData, [field]: value });
        if(value != "") {
            setCryptoErrors({ ...cryptoErrors, [field]: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, [field]: 'Field is required' });
        }
    };

    const getBorderRadiusClass = () => {
        if (style === "sharp") {
          return "rounded-none";
        } else if (style === "pill") {
          return "rounded-full";
        } else {
          return "rounded";
        }
    };

    const getBorderRadiusCardClass = () => {
        if (style === "sharp") {
          return "rounded-none";
        } else if (style === "pill") {
          return "rounded-[25px]";
        } else {
          return "rounded";
        }
    };

    const handleCryptoCountryChange = (e : any) => {
        setCryptoPaymentData({ ...cryptoPaymentData, country: e.target.value })
        if(e.target.value != "") {
            setCryptoErrors({ ...cryptoErrors, ['country']: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, ['country']: 'Field is required' });
        }
    };

    const validateCryptoFields = () => {
        const newErrors: Record<string, string> = {};
        if (!cryptoPaymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!cryptoPaymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!cryptoPaymentData.email.trim()) newErrors.email = 'Field is required';
        if (!cryptoPaymentData.phone.trim()) newErrors.phone = 'Field is required';
        
        setCryptoErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const getQRValue = () => {
        switch (cryptoPaymentData.crypto_currency) {
            case "Bitcoin":
            case "BTC":
                return `bitcoin:${cryptoAddress}?amount=${cryptoAmount}`;
            case "Ethereum":
            case "ETH":
                return `ethereum:${cryptoAddress}?value=${cryptoAmount}`;
            case "USDT":
                return `ethereum:${cryptoAddress}?contract=1234567890&value=${cryptoAmount}`;
            default:
                return cryptoAddress;
        }
    };

    const handlePayNow   = async() => {
        setIsLoading(true)

        if (!validateCryptoFields()) {
            setIsLoading(false);
            return;
        }

        const payload = {
            "client_id" : client_id,
            "unique_payment_link_id" : unique_payment_link_id,
            "payment_chain" : linkData.crypto_details.payment_chain,
            "payment_currency" : linkData.crypto_details.payment_currency,
            "invoice_chain" : linkData.crypto_details.invoice_chain,
            "invoice_currency" : linkData.crypto_details.invoice_currency,
            "invoice_amount" : linkData.crypto_details.invoice_amount,
            "first_name" : cryptoPaymentData?.first_name,
            "last_name" : cryptoPaymentData?.last_name,
            "email" : cryptoPaymentData?.email,
            "phone" : cryptoPaymentData?.phone,
            "country" : cryptoPaymentData?.country
        }

        const wallet_details = await getQuoteDetails(payload);
        if(wallet_details.status) {
            setCryptoAddress(wallet_details.data.address);
            setPaymentAmountRate(wallet_details.data.live_rate);
            setFinalPaymentAmount(wallet_details.data.payment_amount);

            const qrValue = getQRValue() 
            setQrCode(qrValue)
            setIsLoading(false);
            setAddressPreview(true);
            fetchData(false);

        } else {
            setIsLoading(false);
            toast.error(wallet_details.data.message)
        }
    }

    const handleCopyAddress = () => {
        navigator.clipboard.writeText(cryptoAddress);
        setCopiedAddress(true);

        setTimeout(() => {
            setCopiedAddress(false);
        }, 2000);
    };

    const handleCopyAmount = () => {
        navigator.clipboard.writeText(finalPaymentAmount);
        setCopiedAmount(true);

        setTimeout(() => {
            setCopiedAmount(false);
        }, 2000);
    };
    
    return (
        <>
            {initialLoading ? (
                <div className="mt-5 pt-5">
                    <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                    <p className="text-center">Loading, please wait...</p>
                </div>
            ) : (
                <>
                    <div className="flex flex-col lg:flex-row  mx-auto h-[100vh]">
                        <div className="h-full md:w-2/6 lg:w-2/6 sm:w-full border-r-2 p-5" style={{ backgroundColor: brandColor , color : '#FFFFFF' }}>
                            <div className="flex flex-col h-full justify-center items-center gap-6">
                                <img
                                style={{
                                    height: "auto",
                                    width: hostname === "pay.paxum.com" ? "80px" : "150px",
                                    filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.15))",
                                }}
                                src={logos[hostname] || bm2payLogo}
                                alt="Gateway Image"
                                />
                                <div className="text-center">
                                <h3 className="text-lg font-semibold text-white" style={{ fontFamily: selectedFont }}>Fast. Secure. Reliable.</h3>
                                <p className="text-lg text-indigo-200 italic" style={{ fontFamily: selectedFont }}>Your trusted gateway for seamless payments.</p>
                                </div>
                                <div className="text-center">
                                    <h3 className="text-lg font-semibold text-white" style={{ fontFamily: selectedFont }}>
                                        {linkData.crypto_details?.quote_id
                                        ? `Expires In : ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
                                        : null}

                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="w-full sm:w-full md:w-4/6 lg:w-4/6 px-5 py-10 md:px-28 md:py-10 lg:px-28 lg:py-10 ">
                            <div className="flex flex-col space-y-6">
                                <>
                                    <h3 className="text-xl font-semibold mb-4 relative text-center" style={{ fontFamily: selectedFont }}>
                                            <span className="absolute left-0 top-1/2 w-full border-t border-gray-300" style={{ transform: 'translateY(-50%)' }}></span>
                                            <span className="bg-white px-2 relative z-10" style={{ fontFamily: selectedFont }} >Pay with CRYPTO</span>
                                    </h3>
                                    <div className="flex gap-4 mb-5">
                                        <div className="flex flex-col w-full">
                                                <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                    First Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border p-4 w-full ${cryptoErrors.first_name ? 'border-red-500' : ''} ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                    style={{ fontFamily: selectedFont }}
                                                    placeholder="first name"
                                                    value={cryptoPaymentData?.first_name}
                                                    disabled={!!linkData.crypto_details?.first_name?.trim()}
                                                    onChange={(e) => handleCryptoFieldChange('first_name', e.target.value)}
                                                />
                                                {cryptoErrors.first_name && <span className="text-red-500 text-sm">{cryptoErrors.first_name}</span>}
                                        </div>
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Last Name
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full ${cryptoErrors.last_name ? 'border-red-500' : ''} ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="last name"
                                                value={cryptoPaymentData?.last_name}
                                                disabled={!!linkData.crypto_details?.last_name?.trim()}
                                                onChange={(e) => handleCryptoFieldChange('last_name', e.target.value)}
                                            />
                                                {cryptoErrors.last_name && <span className="text-red-500 text-sm">{cryptoErrors.last_name}</span>}
                                        </div>
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Amount
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full  ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="amount"
                                                value={`${linkData.crypto_details.invoice_amount} ${getCurrencySymbol(linkData.crypto_details.invoice_currency)?.icon || linkData.crypto_details.invoice_currency}`}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex gap-4 mb-5">
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Email
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full ${cryptoErrors.email ? 'border-red-500' : ''} ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="test@gmail.com"
                                                value={cryptoPaymentData?.email}
                                                disabled={!!linkData.crypto_details?.email?.trim()}
                                                onChange={(e) => handleCryptoFieldChange('email', e.target.value)}
                                            />
                                            {cryptoErrors.email && <span className="text-red-500 text-sm">{cryptoErrors.email}</span>}
                                        </div>
                                
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Phone Number
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full ${cryptoErrors.phone ? 'border-red-500' : ''} ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="1234567890"
                                                value={cryptoPaymentData?.phone}
                                                disabled={!!linkData.crypto_details?.phone?.trim()}
                                                onChange={(e) => handleCryptoFieldChange('phone', e.target.value)}
                                            />
                                            {cryptoErrors.phone && <span className="text-red-500 text-sm">{cryptoErrors.phone}</span>}
                                        </div>
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Country
                                            </label>
                                            <select
                                                className={`border ${cryptoErrors.country ? 'border-red-500' : ''} ${getBorderRadiusClass()} border-gray-300 p-4 w-full outline-none placeholder-gray-400 dark:placeholder-gray-500`}
                                                onChange={handleCryptoCountryChange}
                                                style={{ fontFamily: selectedFont }}
                                                value={cryptoPaymentData?.country}
                                                disabled={!!linkData.crypto_details?.country?.trim()}
                                                >
                                                {allCountries.map((country) => (
                                                    <option key={country.code} value={country.code}>
                                                    {country.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {cryptoErrors.country && <span className="text-red-500 text-sm">{cryptoErrors.country}</span>}
                                        </div>
                                    </div>
                                    <div className="flex gap-4 mb-5">
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Payment Currency
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full  ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="amount"
                                                value={`${linkData.crypto_details.payment_currency}`}
                                                disabled
                                            />
                                        </div>
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Payment Chain
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full  ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="amount"
                                                value={`${linkData.crypto_details.payment_chain}`}
                                                disabled
                                            />
                                        </div>
                                        <div className="flex flex-col w-full">
                                            <label className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" style={{ fontFamily: selectedFont }}>
                                                Payment Amount
                                            </label>
                                            <input
                                                type="text"
                                                className={`border p-4 w-full  ${getBorderRadiusClass()} border-gray-300 dark:border-white/10 dark:text-white focus:ring-2 focus:ring-blue-500 transition-all outline-none placeholder-gray-400 dark:placeholder-gray-500 shadow-sm hover:shadow-lg transition-shadow`}
                                                style={{ fontFamily: selectedFont }}
                                                placeholder="amount"
                                                value={finalPaymentAmount}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    {!addressPreview && !isExpired ? (
                                        <div className="flex flex-col mt-6">
                                            <button
                                                className={`flex items-center justify-center gap-3 px-6 py-4  text-white font-semibold ${getBorderRadiusClass()} shadow-md transition-transform transform hover:scale-105`}
                                                style={{
                                                    backgroundColor: brandColor,
                                                    boxShadow: `0px 10px 15px -3px ${brandColor}66, 0px 4px 6px -4px ${brandColor}33`,
                                                }}
                                                onClick={handlePayNow}
                                                disabled={isExpired || isLoading}
                                            >
                                                {isLoading ? (
                                                    <DivLoader className="h-6 w-6 border-white" />
                                                ) : (
                                                    <>
                                                    <BsLockFill className="h-5 w-5" />
                                                    <span style={{ fontFamily: selectedFont }} > Generate Quote</span>
                                                    </>
                                                )}
                                                
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            {!isExpired && (
                                                <div className="flex flex-col">
                                                    <label
                                                        className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-200 flex justify-between items-center"
                                                        style={{ fontFamily: selectedFont }}
                                                    >
                                                        <span>Deposit Address</span>
                                                    </label>
                                                    <div className={`border ${getBorderRadiusCardClass()} border-gray-300 dark:border-white/10 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm hover:shadow-lg transition-shadow`}>
                                                        <div className="flex gap-4">
                                                            <div className="flex flex-col w-1/4 py-8 pl-8">
                                                                <QRCodeCanvas  value={qrCode} size={170} level="H" />
                                                            </div>
                                                            <div className="flex flex-col w-3/4 py-8 pr-8">
                                                                <h4 className='font-extrabold text-2xl'>{linkData.crypto_details.payment_currency} ({linkData.crypto_details.payment_chain}) Address</h4>
                                                                <div className='w-full  p-2 mt-2 rounded bg-gray-200'>
                                                                    <div className="flex items-center gap-3">
                                                                        <h4 className='font-semibold text-lg'>
                                                                            {cryptoAddress}
                                                                        </h4>
                                                                        {copiedAddress ? (
                                                                            <BsCheck className="h-5 w-5" />
                                                                        ) : (
                                                                            <BsCopy className="h-5 w-5 cursor-pointer" onClick={handleCopyAddress} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className='w-full  p-2 mt-2 rounded bg-gray-200'>
                                                                    <div className="flex items-center gap-3">
                                                                        <h4 className='font-semibold text-lg'>
                                                                            = {finalPaymentAmount} {cryptoPaymentData.crypto_currency}
                                                                        </h4>
                                                                        {copiedAmount ? (
                                                                            <BsCheck className="h-5 w-5" />
                                                                        ) : (
                                                                            <BsCopy className="h-5 w-5 cursor-pointer" onClick={handleCopyAmount} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className='w-full  mt-2'>
                                                                    <div className="flex items-center gap-3">
                                                                        {/* <h4 className='font-medium text-lg'>
                                                                            {linkData.crypto_details.invoice_amount} {getCurrencySymbol(linkData.crypto_details.invoice_currency)?.icon || linkData.crypto_details.invoice_currency}  =  {finalPaymentAmount} {linkData.crypto_details.payment_currency}
                                                                        </h4> */}
                                                                        <h4 className='font-medium text-lg'>
                                                                            {paymentAmountRate}
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                        <div className="w-full px-8 pb-8">
                                                            <div className="font-medium text-lg border border-red-500 bg-gray-200 rounded p-4">
                                                                You must ensure that you are sending <span className="font-bold">on the selected network</span> otherwise your assets/funds will be lost.
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <Modal isOpen={isOpen} onClose={() => {}}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                {/* <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]"> */}
                <ModalContent className="sm:max-w-xxl z-[1002] !m-auto flex min-h-[100vh] max-w-[800px] justify-center !p-3 sm:my-8 sm:w-full">
                <ModalBody>
                    <Card extra="px-[30px] pt-[38px] pb-5 max-w-[800px]  flex flex-col !z-[1004]">
                    <h1 className="mb-[20px] text-2xl font-bold">Your link is expired!</h1>
                    
                    </Card>
                </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default PayinCheckoutPage
